import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';

import { t } from '../../services/translate';

const RING_RADIUS = 16;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

/** Subtle countdown ring — pure SVG on currentColor, seconds centered inside. */
@Component({
  selector: 'wpp-countdown-timer',
  imports: [],
  templateUrl: './countdown-timer.component.html',
  styleUrl: './countdown-timer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'data-wpp-planner': '',
    role: 'timer',
    '[attr.aria-label]':
      "t('wpp.component.countdown-timer.aria-label', { seconds: secondsLeft() })",
  },
})
export class CountdownTimerComponent {
  /** Seconds remaining; drives both the number and the ring. */
  public readonly secondsLeft = input.required<number>();
  /** Total seconds the countdown started from; a full ring equals this value. */
  public readonly totalSeconds = input.required<number>();

  // Host bindings are evaluated against the class and cannot use a pipe, so this one keeps the
  // direct lookup. Templates use `| translate` instead.
  protected readonly t = t;

  protected readonly radius = RING_RADIUS;
  protected readonly circumference = RING_CIRCUMFERENCE;

  protected readonly dashOffset: Signal<number> = computed((): number => {
    const total: number = Math.max(this.totalSeconds(), 1);
    const fraction: number = Math.min(Math.max(this.secondsLeft() / total, 0), 1);
    return RING_CIRCUMFERENCE * (1 - fraction);
  });
}
